import { DataCacheBase } from '../../../webmodule-common/cache/data-cache-base';
import type { ApiCommunications, NullPromise } from '../../../webmodule-common/interop/webmodule-interop';
import type { ItemReference } from '../../../webmodule-common/cache/definitions/cache-item-reference';
import type {
  RequestGetClientDefaultTermsAndConditionsListByIds,
  ResultGetClientDefaultTermsAndConditionsListByIds
} from '../../api/dealer-api-interface-franchisee';
import type { TermsAndConditionsCacheData } from './cache-data';

export class TermsConditionsCache extends DataCacheBase<TermsAndConditionsCacheData> {
  constructor(api: ApiCommunications) {
    super(api);
    //depending on what high level controller api we create we could swap this to ClientApi etc.
  }

  //override;
  protected async internalFetch(requestIds: string[]): NullPromise<ItemReference<TermsAndConditionsCacheData>[]> {
    if (requestIds.length === 0) return null;

    const input: RequestGetClientDefaultTermsAndConditionsListByIds = {
      termsAndConditionsIds: requestIds
    };
    const result = await this.api.post<ResultGetClientDefaultTermsAndConditionsListByIds>(
      `api/Franchisee/GetClientDefaultTermsAndConditionsListByIds`,
      input
    );
    if (!result) return null;

    return result.termsAndConditionsList.map(tCs => {
      const data: TermsAndConditionsCacheData = { termsAndConditions: tCs };
      const qcr: ItemReference<TermsAndConditionsCacheData> = {
        id: tCs.id,
        displayValue: `${tCs.name}`,
        data: data,
        onClick: null
      };
      return qcr;
    });
  }
}
